<template>
  <section class="hrv-hero hrv-hero--split-stats" aria-label="Главный баннер">
    <div class="hr-container">
      <div class="hrv-hero__split">
        <div class="hrv-hero__left">
          <p class="hrv-hero__eyebrow">{{ data.eyebrow }}</p>
          <h1 class="hrv-hero__title">
            <span class="hrv-hero__title-lead">{{ data.titleLine1 }}</span>
            <span class="hrv-hero__title-brand">{{ data.titleBrand }}</span>
          </h1>
          <p class="hrv-hero__desc">{{ data.description }}</p>
          <div class="hrv-hero__actions">
            <router-link
              v-for="action in data.actions"
              :key="action.label"
              class="hr-btn"
              :class="action.primary ? 'hr-btn--primary' : 'hr-btn--outline'"
              :to="action.to"
            >
              {{ action.label }}
            </router-link>
          </div>
          <ul v-if="stats && stats.length" class="hrv-stats hrv-stats--halo" aria-label="Ключевые показатели">
            <li v-for="item in displayStats" :key="item.label" class="hrv-stats__item">
              <strong class="hrv-stats__value">{{ item.value }}</strong>
              <span class="hrv-stats__label">{{ item.label }}</span>
            </li>
          </ul>
        </div>
        <div class="hrv-hero__right" aria-hidden="true">
          <img :src="data.image" :alt="data.imageAlt || ''" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PaidServicesApi from '@/api/paidServices.js'

function formatStatNumber(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return String(value ?? '—')
  return n.toLocaleString('ru-RU')
}

function formatYearsOfCare(value) {
  const n = Number(value)
  if (!Number.isFinite(n) || n < 0) return '—'
  const abs = Math.abs(Math.trunc(n)) % 100
  const last = abs % 10
  let word = 'лет'
  if (abs > 10 && abs < 20) {
    word = 'лет'
  } else if (last === 1) {
    word = 'год'
  } else if (last >= 2 && last <= 4) {
    word = 'года'
  }
  return `${Math.trunc(n)} ${word}`
}

function formatRating2gis(rating, max) {
  const r = Number(rating)
  const m = Number(max)
  if (!Number.isFinite(r)) return '—'
  const ratingLabel = String(r).replace('.', ',')
  const maxLabel = Number.isFinite(m) && m > 0 ? m : 5
  return `${ratingLabel} из ${maxLabel}`
}

export default {
  name: 'HrHeroSplitStats',
  props: {
    data: { type: Object, required: true },
    stats: { type: Array, default: () => [] },
  },
  data() {
    return {
      displayStats: this.stats.map((item) => ({ ...item })),
    }
  },
  watch: {
    stats: {
      deep: true,
      handler(next) {
        this.displayStats = (next || []).map((item) => ({ ...item }))
      },
    },
  },
  mounted() {
    this.loadStatistics()
  },
  methods: {
    async loadStatistics() {
      if (!this.stats.length) return
      try {
        const response = await PaidServicesApi.getStatistics()
        const result = response && response.data && (response.data.result || response.data)
        if (!result || typeof result !== 'object') return
        this.displayStats = this.stats.map((item) => {
          if (item.kind === 'rating2gis') {
            if (result.rating2gis == null) return { ...item }
            return { ...item, value: formatRating2gis(result.rating2gis, result.rating2gisMax) }
          }
          if (item.kind === 'yearsOfCare') {
            const raw = item.field ? result[item.field] : result.yearsOfCare
            if (raw == null) return { ...item }
            return { ...item, value: formatYearsOfCare(raw) }
          }
          if (!item.field || result[item.field] == null) return { ...item }
          return { ...item, value: formatStatNumber(result[item.field]) }
        })
      } catch (e) {
        console.warn('HrHeroSplitStats: статистика недоступна', e)
      }
    },
  },
}
</script>
